/* @flow */
/**
 * Created by Ondra on 20.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {changeMenuPanel, closeMenu} from '../../common/menu/actions';
import {setAllowSale, setForbidSale, fetchOnlyCategories} from '../../common/categories/actions';
import {fetchDailyReportSum, closePrintDailySum} from '../../common/report/actions';
import {lockUser} from '../../common/users/actions';
import {isNeedArrayPrint, preparePrintArray, print, isEnv, getVersion, getRelease} from '../../common/lib/util';

class MenuList extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        dailySum: React.PropTypes.object,
        printDailySum: React.PropTypes.bool,
        organization: React.PropTypes.object,
        branch: React.PropTypes.object,
        cashboxes: React.PropTypes.object,
        closeMenu: React.PropTypes.func,
        prepareDailySum: React.PropTypes.func,
        lockUser: React.PropTypes.func,
        changeMenuPanel: React.PropTypes.func,
        closePrintDailySum: React.PropTypes.func,
        fetchDailyReportSum: React.PropTypes.func,
        fetchOnlyCategories: React.PropTypes.func,
        setAllowSale: React.PropTypes.func,
        setForbidSale: React.PropTypes.func,
        bar: React.PropTypes.object,
        menuTypes: React.PropTypes.object,
        printingInProgress: React.PropTypes.bool,
        showButtonLock: React.PropTypes.bool,
        onlineState: React.PropTypes.bool,
        menuType: React.PropTypes.string,
        silentPrint: React.PropTypes.bool,
        deviceId: React.PropTypes.number,
        printType: React.PropTypes.string,
        printAddress: React.PropTypes.string,
        printLength: React.PropTypes.number
    }

    constructor(props) {
        super(props);

        this.printDailyItems = this.printDailyItems.bind(this);
        this.lockUser = this.lockUser.bind(this);
        this.print = this.print.bind(this);
    }

    lockUser() {
        const {lockUser, closeMenu} = this.props;
        lockUser();
        closeMenu();
    }

    print() {
        const {
            printType, setAllowSale, closePrintDailySum, bar, organization, branch, cashboxes, printDailySum,
            dailySum, deviceId, silentPrint, printAddress, printLength, msg
        } = this.props;

        const printArray = !!isNeedArrayPrint(printType)
            ? preparePrintArray(bar, organization, null, branch, cashboxes, null, printDailySum, dailySum, deviceId, msg)
            : null;

        print(printType, printAddress, printArray, silentPrint, printLength, false, null);
        setTimeout(function () {
            setAllowSale();
            closePrintDailySum();
        }, 3500);
    }

    printDailyItems() {
        const {
            printingInProgress, fetchDailyReportSum, setAllowSale, setForbidSale, bar
        } = this.props;

        if (!printingInProgress) {
            setForbidSale();
            fetchDailyReportSum(bar.get('id'))
                .payload.promise
                .then(res => {
                    const print = this.print();
                    setTimeout(function () {
                        print();
                    }, 1000);
                })
                .catch(res => {
                    console.err('offline');
                    setAllowSale();
                });
        }
    }

    render() {
        const {printingInProgress, menuTypes, changeMenuPanel, onlineState, menuType, showButtonLock, msg} = this.props;

        let version = null;
        let release = null;

        if (isEnv(['android_app', 'electron'])) {
            version = getVersion();
            release = getRelease();
        }

        return (
            <div className="menuList">

                {(!!version || !!release) &&
                    <div className="menuList-version">
                        {!!release &&
                            <p>Release: {release}</p>
                        }
                        {!!version &&
                            <p>Version: {version}</p>
                        }
                    </div>
                }

                <div className="menuList-column">

                </div>

                <div className="menuList-column">

                    <div className="menuList-key"></div>
                    {!showButtonLock &&
                      <div className="menuList-key"></div>
                    }

                  <div className="menuList-key">
                    <div className={`boxBtn color-white text-l`}
                         onClick={() => changeMenuPanel(menuTypes.STORNO)}>
                        <div className="boxBtn-inner">
                            <span>{msg.menu.issuedReceipts}</span>
                        </div>
                    </div>
                  </div>
                  <div className="menuList-key">
                    <div className={`boxBtn text-l color-${menuType === menuTypes.REPORT_MENU ? 'red' : 'white'} ${onlineState ? '' : 'disabled'}`}
                         onClick={() => changeMenuPanel(menuType === menuTypes.REPORT_MENU ? null : menuTypes.REPORT_MENU)}>
                        <div className="boxBtn-inner">
                            <span>
                                {msg.menu.dailyReport} {!onlineState && msg.menu.offlineMode}
                              <div className="menuList-key-arr">
                                <div className="ico-right"></div>
                              </div>
                            </span>
                        </div>
                    </div>
                  </div>
                  <div className="menuList-key">
                    <div className={`boxBtn text-l color-white ${onlineState ? '' : 'disabled'}`}
                         onClick={() => changeMenuPanel(menuTypes.CREDITS)}>
                        <div className="boxBtn-inner">
                            <span>{msg.menu.credits} {!onlineState && msg.menu.offlineMode}</span>
                        </div>
                    </div>
                  </div>
                  <div className="menuList-key">
                    <div className={`boxBtn color-white text-l`}
                         onClick={() => changeMenuPanel(menuTypes.FAVOURITE)}>
                        <div className="boxBtn-inner">
                            <span>{msg.menu.favourites}</span>
                        </div>
                    </div>
                  </div>
                  <div className="menuList-key">
                    <div className={`boxBtn color-white text-l`}
                         onClick={() => changeMenuPanel(menuTypes.SETTINGS)}>
                        <div className="boxBtn-inner">
                            <span>{msg.menu.settings}</span>
                        </div>
                    </div>
                  </div>

                    {showButtonLock &&
                      <div className="menuList-key">
                          <div className={`boxBtn color-white text-l`}>
                              <div className="boxBtn-inner"
                                   onClick={this.lockUser}>
                                  <span>{msg.menu.lock}</span>
                              </div>
                          </div>
                      </div>
                    }
                </div>

                {menuType === menuTypes.REPORT_MENU &&
                    <div className="menuList-column view-right">
                      <div className="menuList-key"></div>
                      <div className="menuList-key"></div>
                      <div className="menuList-key">
                        <div className={`boxBtn color-white text-l ${!printingInProgress ? '' : 'disabled'} ${onlineState ? '' : 'disabled'}`}
                             onClick={() => this.printDailyItems()}>
                            <div className="boxBtn-inner">
                                <span>{msg.global.print} {!onlineState && msg.menu.offlineMode}</span>
                            </div>
                        </div>
                      </div>
                      <div className="menuList-key">
                        <div className={`boxBtn color-white text-l ${onlineState ? '' : 'disabled'}`}
                             onClick={() => changeMenuPanel(menuTypes.SHIFTS)}>
                            <div className="boxBtn-inner">
                                <span>{msg.menu.shifts} {!onlineState && msg.menu.offlineMode}</span>
                            </div>
                        </div>
                      </div>
                      <div className="menuList-key">
                        <div className={`boxBtn color-white text-l ${onlineState ? '' : 'disabled'}`}
                             onClick={() => changeMenuPanel(menuTypes.TRANSACTIONS)}>
                            <div className="boxBtn-inner">
                                <span>{msg.menu.payouts} {!onlineState && msg.menu.offlineMode}</span>
                            </div>
                        </div>
                      </div>
                      <div className="menuList-key">
                        <div className={`boxBtn color-white text-l ${onlineState ? '' : 'disabled'}`}
                             onClick={() => changeMenuPanel(menuTypes.CALCULATE_CASHBOXES)}>
                            <div className="boxBtn-inner">
                                <span>{msg.menu.cashboxState} {!onlineState && msg.menu.offlineMode}</span>
                            </div>
                        </div>
                      </div>
                    </div>
                }
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    bar: state.bars.get('bar'),
    printingInProgress: state.categories.get('printingInProgress'),
    onlineState: state.categories.get('onlineState'),
    menuType: state.menu.get('menuType'),
    menuTypes: state.menu.get('menuTypes'),
    silentPrint: state.device.get('silentPrint'),
    printType: state.device.get('printType'),
    printAddress: state.device.get('printAddress'),
    showButtonLock: state.users.get('showButtonLock'),
    branch: state.branches.get('branch'),
    cashboxes: state.cashboxes.get('cashboxes'),
    deviceId: state.device.get('id'),
    organization: state.categories.get('organization'),
    printDailySum: state.barReport.get('printDailySum'),
    dailySum: state.barReport.get('dailySum'),
    printLength: state.device.get('printLength')
}), {
    setAllowSale, setForbidSale, fetchOnlyCategories, lockUser,
    fetchDailyReportSum, closePrintDailySum, changeMenuPanel, closeMenu
})(MenuList);



// WEBPACK FOOTER //
// ./src/browser/menu/MenuList.js